module.exports = __webpack_public_path__ + "img/selected1-min.950d9182.png";